export class Event {
  id: string;
  text: string;
  userId?: string;
  type: string;
  dateFrom: number;
  duration: number;
  textColor: string;
  backgroundColor: string;
  leadId: string;
  status: string;

  constructor(eventEntityPartial?: Partial<Event>) {
    Object.assign(this, eventEntityPartial);
  }
}
